import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";

export const Card = styled.section`
    background: ${colors.surface};
    border-radius: ${radii.base};
    box-shadow: ${shadows.panel};
    padding: 18px 24px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        padding: 16px;
    }
`;

// Четыре подписи в ряд на телефон не влезают — там вместо ряда строка с полосой прогресса.
export const Wide = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const Compact = styled.div`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: block;
    }
`;

export const Step = styled.button<{ $clickable: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 0 0 auto;
    padding: 0;
    border: 0;
    background: none;
    font-family: inherit;
    cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;

export const Marker = styled.span<{ $done: boolean; $current: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    flex: 0 0 auto;
    background: ${({ $done, $current }) => ($done || $current ? colors.primary : "transparent")};
    border: ${({ $done, $current }) =>
        $done || $current ? "0" : `1px solid ${colors.fieldBorder}`};
    color: ${({ $done, $current }) =>
        $done || $current ? colors.surface : colors.textSecondary};

    svg {
        font-size: 16px;
    }
`;

export const StepLabel = styled.span<{ $done: boolean; $current: boolean }>`
    font-size: 14px;
    font-weight: ${({ $done, $current }) => ($current ? 700 : $done ? 600 : 400)};
    color: ${({ $done, $current }) =>
        $current ? colors.primary : $done ? colors.textPrimary : colors.textSecondary};
`;

export const Connector = styled.span<{ $done: boolean }>`
    flex: 1 1 auto;
    height: 1px;
    margin: 0 14px;
    background: ${({ $done }) => ($done ? colors.primary : colors.fieldBorder)};
`;

export const CompactHeader = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
`;

export const CompactTitle = styled.span`
    font-size: 0.9375rem;
    font-weight: 700;
    color: ${colors.primary};
`;

export const CompactNext = styled.span`
    font-size: 12px;
    color: ${colors.textSecondary};
    white-space: nowrap;
`;

export const Progress = styled.div`
    display: flex;
    gap: 4px;
    margin-top: 10px;
`;

export const ProgressSegment = styled.span<{ $done: boolean }>`
    flex: 1;
    height: 4px;
    border-radius: 2px;
    background: ${({ $done }) => ($done ? colors.primary : colors.fieldBorder)};
`;
